import { NAVIGATION_COPY } from '@/locales/en'
import { DetailListItem } from '@/common/ui/DetailListItem'
import type { ActionableDetailItem, DetailItem } from '../types'

export function ActionableDetailItemRow({ item }: { item: ActionableDetailItem }) {
    const copy = NAVIGATION_COPY.account.accountFields
    const isNotProvided = item.value === '-' && !!item.onAdd

    return (
        <DetailListItem
            label={item.label}
            value={item.value}
            isNotProvided={isNotProvided}
            onAction={item.onAdd}
            notProvidedMessage={copy.tradeConfirmationNotProvided}
            actionLabel={copy.tradeConfirmationAdd}
        />
    )
}

export function DetailItemContent({ item }: { item: DetailItem }) {
    return (
        <div className="self-stretch inline-flex justify-start items-center gap-3 md:gap-4">
            <DetailListItem label={item.label} value={item.value} />
        </div>
    )
}
